import { render, staticRenderFns } from "./SettingsFlexColumnAlignSelf.vue?vue&type=template&id=1b11ce7c&"
import script from "./SettingsFlexColumnAlignSelf.vue?vue&type=script&lang=js&"
export * from "./SettingsFlexColumnAlignSelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports